import endOfMonth from "date-fns/endOfMonth";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import getYear from "date-fns/getYear";
import parseISO from "date-fns/parseISO";

interface getNumberDayMonthYearIProps {
  date: Date | string | number;
  separator?: "." | "/" | "-";
}
interface getParseIProps {
  date: any;
  atr:
    | "MM"
    | "yy"
    | "yyyy"
    | "dd"
    | "dd-MM-yyyy"
    | "dd.MM.yyyy"
    | "MM.yy"
    | "MM.yyyy"
    | "yy/MM";
}

export const getYearOptionsForSelect = () => {
  const options = [];
  const min = 2014;
  const current = getYear(new Date());

  for (let year = min; year <= current; year++) {
    options.push(year);
  }

  return options.reverse();
};

export const getNumberDayMonthYear = ({
  date,
  separator = ".",
}: getNumberDayMonthYearIProps) => {
  //01.01.2025
  return format(new Date(date), `dd${separator}MM${separator}yyyy`);
};

export const getNumberYearMonthDay = ({
  date,
  separator = ".",
}: getNumberDayMonthYearIProps) => {
  //2025.01.01
  return format(new Date(date), `yyyy${separator}MM${separator}dd`);
};

export const getFullTimeWithTimestamp = (date: string | number | Date) => {
  //2025-05-25T21:46:11+03:00
  return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ssxxx");
};

export const getEndOfDayWithTimestamp = (date: string | number | Date) => {
  //2025-05-08T23:59:59+03:00
  return format(endOfDay(new Date(date)), "yyyy-MM-dd'T'HH:mm:ssxxx");
};

export const getParseISO = ({ date, atr }: getParseIProps) => {
  //2025-05-25T21:46:11+04:00=>26.05.2025
  return format(parseISO(date), atr);
};

export const getFormatDate = ({ date, atr }: getParseIProps) => {
  //2025-05-25T21:46:11+03:00=>25.05.2025
  const point = date.indexOf("T");
  if (point >= 0) {
    let res = date.slice(0, point);

    return format(new Date(res), atr);
  } else {
    return format(new Date(date), atr);
  }
};
